import { useMemo } from 'react'
import { SolopreneurOverview } from '@layerfi/components'
import { useNavigate } from 'react-router-dom'

import { AccountingLayout } from '../../layouts/AccountingLayout'

export const useSolopreneurInteractionProps = () => {
  const navigate = useNavigate()
  return useMemo(() => ({
    cashflowSummaries: {
      onTransactionsToReviewClick: () => {
        navigate('../bank-transactions')
      }
    },
    banner: {
      onSetupTaxProfile: () => {
        navigate('../tax-estimates')
      },
    },
    summaryCards: {
      expenses: {
          onClickExpand: () => {
            navigate('../bank-transactions')
          }
        },
        taxEstimates: {
          onClickExpand: () => {
            navigate('../tax-estimates')
          }
        },
        profitAndLoss: {
          onClickExpand: () => {
            navigate('../reports')
          }
        },
        mileageTracking: {
          onClickExpand: () => {
            navigate('../mileage-tracking')
          }
        },
      },
  }), [navigate])
}

export const SolopreneurPage = () => {
  const interactionProps = useSolopreneurInteractionProps()

  return (
    <AccountingLayout>
      <SolopreneurOverview
        interactionProps={interactionProps}
      />
    </AccountingLayout>
  )
}
